export default __webpack_public_path__ + "static/media/Maithili_tech_f.d6ce7ce7.wav";